/**
 * A base class that handles timeline tracking.
 */
 export default class Timeline {

    /**
     * @constructs Timeline
     * @param      {Number[]} percentages
     *             Percentages that should be tracked. Only whole
     *             percentages are allowed (e.g. 12 not 12.5).
     * @param      {Element} [element]
     *             Optional element that manages the timeline.
     */
    constructor(percentages, element) {

        /**
         * The element that manages the timeline.
         * @type {Element}
         */
        this.element = element;

        /**
         * The percentages, in numberic order.
         * @type {Number[]}
         */
        this.times = percentages
            .map((percentage) => this.normalisePercentage(percentage))
            .sort((a, b) => a - b);

        /**
         * Flags for each of the percentages so we know to only track them
         * once.
         * @type {Object}
         */
        this.flags = percentages.reduce((flags, percentage) => {

            flags[percentage] = false;

            return flags;

        }, {});

        /**
         * Name of the event to track.
         * @type {String}
         */
        // this.eventName = this.discoverEventName();

        /**
         * Event actions for certain percentages.
         * @type {Object}
         */
        // this.eventActions = this.discoverEventActions();

        /**
         * Name of the video.
         * @type {String}
         */
        // this.videoName = this.discoverVideoName();

        /**
         * ID of the video.
         * @type {String}
         */
        // this.videoId = this.discoverVideoId();

        /**
         * Tracking names for certain percentages.
         * @type {Object}
         */
        // this.trackingNames = this.discoverTrackingNames();

        this.setup();

    }

    /**
     * Normalises the given percentage to make sure it's a number in the
     * format that we're expecting. Currently that means that the number is
     * rounded.
     *
     * @param  {Number} percentage
     *         Percentage to normalise.
     * @return {Number}
     *         Normalised percentage.
     */
    normalisePercentage(percentage) {
        return Math.round(percentage);
    }

    /**
     * Returns the name of the event.
     *
     * @return {String}
     *         Name of the event.
     */
    // discoverEventName() {
    //     return this.element.dataset.videoEventName || "video";
    // }

    /**
     * Returns the event actions for certain percentages. If the percentage
     * is not mentioned, the event action would be "video milestone X" where
     * "X" is the percentage.
     *
     * @return {Object}
     *         Event actions.
     */
    // discoverEventActions() {
    //
    //     var data = this.element.dataset.videoEventActions;
    //
    //     if (data) {
    //         data = JSON.parse(data);
    //     } else {
    //
    //         data = {
    //             "0": "video start",
    //             "100": "video complete"
    //         };
    //
    //     }
    //
    //     return data;
    //
    // }

    /**
     * Returns the name of the video.
     *
     * @return {String}
     *         Name of the video.
     */
    // discoverVideoName() {
    //     return this.element.dataset.videoName || "";
    // }

    /**
     * Returns the ID of the video.
     *
     * @return {String}
     *         ID of the video.
     */
    // discoverVideoId() {
    //     return this.element.dataset.videoId || "";
    // }

    /**
     * Returns the tracking name for certain percentages. If the percentage
     * is not mentioned, the tracking name will be the same as the event
     * action. See {@link Timeline#discoverEventActions}.
     *
     * @return {Object}
     *         Tracking names.
     */
    // discoverTrackingNames() {
    //
    //     var data = this.element.dataset.videoTrackingNames;
    //
    //     if (data) {
    //         data = JSON.parse(data);
    //     } else {
    //
    //         data = {
    //             "0": "video start",
    //             "100": "video complete"
    //         };
    //
    //     }
    //
    //     return data;
    //
    // }

    /**
     * Sets up the timeline. This method sound be replaced by subclasses so
     * that the signature of the constructor doesn't need to be reproduced
     * each time.
     *
     * @abstract
     */
    setup() {
        return;
    }

    /**
     * Starts the ticking to track the timeline.
     */
    startTicking() {

        /**
         * A flag to know whether or not the ticking is occurring.
         * @type {Boolean}
         */
        this.isTicking = true;
        this.tick();

        let url = this.element.getAttribute("src")
        let fileName = url.substring(url.lastIndexOf('/')+1)

        _satellite.track("video_interaction", {
            video_interaction_type : "Play",
            video_id : "internal",
            video_name : fileName,
        });

    }

    /**
     * Stops the ticking.
     */
    stopTicking() {
        this.isTicking = false;

        console.log('asd');
        
        let url = this.element.getAttribute("src")
        let fileName = url.substring(url.lastIndexOf('/')+1)
 
        _satellite.track("video_interaction", {
            video_interaction_type : "Pause",
            video_id : "internal",
            video_name : fileName,
        });
    }

    /**
     * Handles a tick occurring. This function will call itself unless or
     * until {@link Timeline#isTicking} becomes falgs (see
     * {@link Timeline#startTicking} and
     * {@link Timeline#stopTicking}).
     */
    tick() {

        var that = this;

        that.checkPercentage(that.getPercent());
        window.requestAnimationFrame(function () {

            if (that.isTicking) {
                that.tick();
            }

        });

    }

    /**
     * Gets the percentage of the timeline's progress. This function will
     * throw an error if it is not replaced with a subclass.
     *
     * @abstract
     * @return   {Number}
     *           Current percentage.
     */
    getPercent() {

        throw new Error(
            "Timeline#getPercent() has not been set."
        );

    }

    /**
     * Checks the given percentage to see if any tracking needs to occur.
     *
     * @param {Number} percentage
     *        Percentage to check.
     */
    checkPercentage(percentage) {

        var round = this.normalisePercentage(percentage);
        var times = this.times;
        var flags = this.flags;
        var i = 0;
        var il = times.length;

        while (i < il && round >= times[i]) {

            if (flags[round] === false) {

                this.track(round);
                flags[round] = true;

            }

            i += 1;

        }

    }

    /**
     * Tracks the percentage.
     *
     * @param {Number} percentage
     *        Percentage to be tracked.
     */
    track(percentage) {       
        let url = this.element.getAttribute("src")
        let fileName = url.substring(url.lastIndexOf('/')+1)

        _satellite.track("video_interaction", {
            video_interaction_type : percentage+"% viewed",
            video_id : "internal",
            video_name : fileName,
        }); 
    }

    /**
     * Resets the given percentages so they can be tracked again. This
     * method will take the percentage to reset, an array of percentages or,
     * if nothing is passed, all percentages will be reset.
     *
     * @param {Number|Number[]} [percentages]
     *        Percentage(s) to reset. If omitted, all percentages are reset.
     */
    // reset(percentages) {
    //
    //     if (percentages === undefined) {
    //         percentages = Object.keys(this.flags);
    //     } else if (!Array.isArray(percentages)) {
    //         percentages = [percentages];
    //     }
    //
    //     percentages.forEach((flag) => {
    //
    //         if (this.flags[flag]) {
    //             this.flags[flag] = false;
    //         }
    //
    //     });
    //
    // }

}
